import type { ReactNode } from "react";

import clsx from "clsx";
import { Cell as AriaCell, Row as AriaRow } from "react-aria-components";

import styles from "./table-row.module.css";
type TableRowProps = {
	children: ReactNode;
	href: string;
	id?: string;
	isLoading: boolean;
};

export function TableRow({ children, href, id, isLoading }: TableRowProps) {
	return (
		<AriaRow
			className={clsx(styles.row, isLoading && styles.rowLoading)}
			href={isLoading ? undefined : href}
			id={id}
		>
			<AriaCell style={{ padding: 0, width: 0 }} />
			{children}
			<AriaCell style={{ padding: 0, width: 0 }} />
		</AriaRow>
	);
}
